export default "__VITE_ASSET__DLRnPE2Z__"